<b3-modal
  #errorModal
  [open]="open"
  overlay
  size="md"
  (b3-close)="onModalDismiss()">
  <b3-modal-header
    heading="Erro"
    aria-level="2"
    icon="cancel"
    icon-tone="danger"
    close-aria-label="Fechar">
  </b3-modal-header>

  <b3-modal-body>
    <p class="characteristic-consult-error-modal__text">{{ message }}</p>
  </b3-modal-body>

  <b3-modal-footer>
    <div class="characteristic-consult-error-modal__footer">
      <b3-button
        type="button"
        variant="filled"
        tone="default"
        (b3-click)="onDismiss()">
        <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
        Entendi
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
